@for (customAttribute of customAttributeFilters; track customAttribute; let i = $index) {
  <div class="filter-section"
    [class.text-input-type]="customAttribute.type === customAttributeType.TEXT">

    @if (customAttribute.type === customAttributeType.SELECT_ANY && customAttribute.options.length > maxSelectAnyOptions) {
      <sl-searchable-select-any-input [customAttribute]="customAttribute"
        (optionsChanged)="handleCustomAttributeInputSubmit($event, i)"/>
    } @else {
      <custom-attribute-input [customAttribute]="customAttribute"
        [autoSubmit]="true"
        (onSubmit)="handleCustomAttributeInputSubmit($event, i)"/>
    }
  </div>
}
